<script setup lang="ts">
import type { PlpGridProps } from './PlpGrid.props'
withDefaults(defineProps<PlpGridProps>(), {
  onlyBorderTop: false,
  showOnlyFirstRow: false,
})
const { isArmaniExchangeWebsite, isEmporioArmaniWebsite } = useWebsite()
</script>
<template>
  <ul
    class="grid"
    :class="[
      { '!border-t-[1px]': onlyBorderTop },
      { 'hide-subsequent-rows !gap-0 !border-0': showOnlyFirstRow },
      gridConfiguration.class,
      isEmporioArmaniWebsite || isArmaniExchangeWebsite
        ? 'grid-borders-black gap-[1px] border-[1px]'
        : 'grid-borders-grey gap-[1px] border-[1px]',
    ]"
  >
    <slot />
  </ul>
</template>
<style lang="scss" scoped>
.grid-borders-grey {
  border-color: solid var(--colorStrokeCardDefault);
  background-color: var(--colorBackgroundPlp);
}

.grid-borders-black {
  border-color: solid var(--colorStrokeCardHover);
  background-color: var(--colorBackgroundPlp);
}

.hide-subsequent-rows {
  grid-template-rows: auto 0px;
  grid-auto-rows: 0;
}
</style>
